import {connect} from "react-redux";
import {
  getDropDownsList, 
  addDropDown, 
  updateDropDown, 
  deleteDropDown, 
} from '../actions/actions-drop-downs';
import {
  GET_BOPINSTITUTIONS_LIST
  , ADD_BOPINSTITUTION
  , UPDATE_BOPINSTITUTION
  , DELETE_BOPINSTITUTION
} from '../actions/action-constants';
import BOPInstitutions from '../components/settings/bop-institutions';
const mapStateToProps = (state, ownProps) => {
  return {
    bopinstitutions: state.bopinstitutionsR
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    getBOPInstitutions: (params) => {
      dispatch(getDropDownsList( params, GET_BOPINSTITUTIONS_LIST) );}
    , addBOPINSTITUTION: (params) => {
      dispatch(addDropDown(params, ADD_BOPINSTITUTION)).then(() => dispatch(getDropDownsList( params, GET_BOPINSTITUTIONS_LIST) ) )  ;}
    , updateBOPInstitution: (id, params) => {
      dispatch(updateDropDown(id, params, UPDATE_BOPINSTITUTION)).then(() => dispatch(getDropDownsList( params, GET_BOPINSTITUTIONS_LIST) ) )  ;}
    , deleteBOPInstitution: (id, params) => {
      dispatch(deleteDropDown(id, params, DELETE_BOPINSTITUTION)).then(() => dispatch(getDropDownsList( params, GET_BOPINSTITUTIONS_LIST) ) )  ;}
  };
};
const BOPInstitutionListContainer = connect(mapStateToProps, mapDispatchToProps)(BOPInstitutions);
export default BOPInstitutionListContainer;